import React from "react";

const PostReview = () => {
  return (
    <div className="bg-gray-10 border border-gray-200 p-2  flex flex-col max-w-[400px] ">
      <p className="text-gray-800 text-sm  font-normal">
        <span className="font-bold">Post Review:</span> After the review & once interventions are 
          complete,  this becomes the updated  Personal Medication Record
          If there are no interventions, then Post review becomes the list.
      </p>
    </div>
  );
};

export default PostReview;
